import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { IoMdPeople } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";

const route = all_routes;
export const SidebarData = [
  {
    // label: "CRM",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      // {
      //   label: "Dashboard",
      //   icon: "ti ti-layout-2",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.adminDashboard,
      // },
      // {
      //   label: "Speak To Lead",
      //   icon: "ti ti-medal",
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     // { label: "Calls", link: route.allCalls, icon: <IoMdPeople /> },
      //     {
      //       label: "Script",
      //       link: route.scriptGenerator,
      //       icon: <IoMdPeople />,
      //     },
      //   ],
      // },
      {
        label: "Companies",
        icon: "ti ti-user-up",
        submenu: false,
        showSubRoute: false,
        link: route.adminCompaniesList,
      },
      {
        label: "Tickets",
        icon: "ti ti-code",
        submenu: false,
        showSubRoute: false,
        link: route.manageTickets,
      },

      // {
      //   label: "Contacts",
      //   icon: "ti ti-user-up",
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     {
      //       label: "Contacts List",
      //       link: route.contactList,
      //       icon: <IoMdPeople />,
      //     },
      //     {
      //       label: "FAQ",
      //       link: route.contactFaq,
      //       icon: <IoMdPeople />,
      //     },
      //   ],
      // },
      // {
      //   label: "Leads",
      //   icon: "ti ti-medal",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.leads,
      //   onClick: () => console.log("Leads Clicked"),
      // },
      // {
      //   label: "Calendar",
      //   icon: "ti ti-medal",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.calendar,
      // },

      // {
      //   label: "Settings",
      //   icon: "ti ti-code",
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     {
      //       label: "Profile Settings",
      //       link: route.profile,
      //       icon: <IoMdPeople />,
      //     },
      //     {
      //       label: "Security",
      //       link: route.security,
      //       icon: <IoMdPeople />,
      //     },
      //     {
      //       label: "Manage Statuses",
      //       link: route.contact_statuses,
      //       icon: <IoMdPeople />,
      //     },
      //   ],
      // },
      //  {
      //   label: "Sync And Integration",
      //   icon: "ti ti-layout-2",
      //   submenu: false,
      //   showSubRoute: false,
      //    link: route.syncAndIntegration,

      // },
      // {
      //   label: "Call Logs / Recordings",
      //   icon: "ti ti-layout-2",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.agentCallAndRecording,
      // },
      // {
      //   label: "Import And Export",
      //   icon: "ti ti-layout-2",
      //   submenu: false,
      //   showSubRoute: false,
      //   link: route.importAndExport,
      // },
      //  {
      //   label: "API",
      //   icon: "ti ti-layout-2",
      //   submenu: false,
      //   showSubRoute: false,
      //    link: route.api,

      // },

      // {
      //   label: "Upgrade Plan",
      //   icon: "ti ti-code",
      //   submenu: false,
      //   link: route.upgradePlan,
      //   showSubRoute: false,
      // },
      // {
      //   label: "Help & Support",
      //   icon: "ti ti-code",
      //   submenu: true,
      //   showSubRoute: false,
      //   submenuItems: [
      //     {
      //       label: "New Ticket",
      //       link: route.helpAndSupport,
      //       icon: <IoMdPeople />,
      //     },
      //     {
      //       label: "Existing Ticket",
      //       link: route.myTickets,
      //       icon: <IoMdPeople />,
      //     },
      //   ],
      // },
      {
        label: "Settings",
        icon: "ti ti-settings",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Profile Settings",
            link: route.adminProfile,
            icon: <IoMdPeople />,
          },
          {
            label: "Security",
            link: route.adminSecurity,
            icon: <IoMdPeople />,
          },
        ],
      },
    ],
  },
];
